import { ChangeEvent, FC, MouseEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import "./EditForm.css";
import {
  editOperator,
  removeOperator,
} from "../../../redux/requests/OperatorRequests";
import { projectType } from "../../../redux/types/OperatorTypes";

interface IOperatorEditProps {}

const OperatorEdit: FC<IOperatorEditProps> = () => {
  const params = useParams();
  const operator = useAppSelector((state) =>
    state.operator.operators.find((item) => item.id === params.id)
  );

  const dispatch = useAppDispatch();

  const [login, setLogin] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [fullName, setFullName] = useState<string>("");
  const [project, setProject] = useState<projectType>(projectType.eHukumat);
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    if (operator) {
      setFullName(operator.name);
      setLogin(operator.login);
    }
  }, [operator]);

  const onLoginInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLogin(event.target.value);
  };

  const onFullNameInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFullName(event.target.value);
  };

  const onPasswordInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const onSaveClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    let data = {};
    if (login.trim() && login.trim() !== operator?.login)
      data = {
        login: login.trim(),
        ...data,
      };

    if (password.trim())
      data = {
        password: password.trim(),
        ...data,
      };

    if (fullName.trim() && fullName.trim() !== operator?.name)
      data = {
        name: fullName.trim(),
        ...data,
      };
    if (project && project !== operator?.project) {
      data = {
        ...data,
        project: project,
      };
    }
    if (Object.keys(data).length !== 0) {
      if (operator)
        dispatch(editOperator(operator?.id, data)).then((data) => {
          if (data) {
            navigate("/admin");
          } else {
            setError("Ошибка! Повторите снова!");
          }
        });
    } else {
      setError("Нет никаких изменений!");
    }
  };

  const onDeleteClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (operator)
      dispatch(removeOperator(operator.id)).then((data) => {
        if (data) {
          navigate("/admin");
        } else {
          setError("Ошибка! Повторите снова!");
        }
      });
  };

  return (
    <div className="edit">
      <div className="edit-container">
        <h1>Оператор {operator?.name}</h1>
        <div className="edit-inputs">
          <input
            type="text"
            placeholder="Логин"
            value={login}
            required
            onChange={onLoginInputChange}
          />
          <input
            type="password"
            placeholder="Пароль"
            required
            onChange={onPasswordInputChange}
          />
          <input
            type="text"
            placeholder="ФИО"
            value={fullName}
            required
            onChange={onFullNameInputChange}
          />
          <select
            value={project}
            onChange={(e) => setProject(e.target.value as projectType)}
            required
          >
            <option value={projectType.eDo}>Документооборот</option>
            <option value={projectType.eHukumat}>
              Госсударственные услуги
            </option>
          </select>
        </div>
        <div className="edit-buttons">
          <button className="edit-btn" onClick={onSaveClick}>
            Сохранить изменения
          </button>
          <button className="delete-op-btn" onClick={onDeleteClick}>
            Удалить
          </button>
        </div>
        <p className="error-label">{error}</p>
      </div>
    </div>
  );
};

export default OperatorEdit;
